export default __webpack_public_path__ + "static/media/category_create_h.e812a7b1.svg";